(ns frontend.ui.component.lp-portal.voima-components.free-text-card.free-text-card
  (:require
   [common.time :as c-time]
   [common.util :as cu]
   [frontend.ui.component.lp-portal.voima-components.card.view :as card]
   [frontend.ui.component.lp-portal.voima-components.text-content.view :as text-content]
   [frontend.ui.component.lp-portal.voima-components.card.style :as card-style]
   [herb.core :refer [<class]]))

(defn free-text
  [{:keys [rich-content rich-content-path
           rich-content-completed-at rich-content-completed-path]}
   {:keys [edit-mode? show-draft? save-text]}]
  [text-content/rich-text-content
   {:html-content      rich-content
    :completed-at      rich-content-completed-at
    :complete-changed! (when (and edit-mode?
                                  (fn? save-text))
                         (fn [new-content completed?]
                           (save-text rich-content-path
                                      new-content
                                      rich-content-completed-path
                                      (if completed?
                                        ""
                                        (str (c-time/now-millis))))))
    :show-draft?       show-draft?
    :can-edit?         edit-mode?
    :on-change         (when (and edit-mode?
                                  (fn? save-text))
                         (fn [new-content]
                           (println "SAVE TEXT CHANGED!")
                           (save-text rich-content-path new-content)))
    :background-color? false}])

(defn free-text-section
  [title text-data props]
  [:div {:class (<class card-style/free-text-card)}
   [:div
    {:class (<class card-style/title (merge props {:blank-title? (cu/blank-value? title)}))}
    title]
   [free-text text-data props]])

(defn view
  [title
   {:keys [_rich-content _rich-content-path] :as text-data}
   {:keys [_edit-mode? _save-text] :as props}]
  [card/card {:title title}
   [free-text text-data props]])
